import { render, staticRenderFns } from "./nav-modular.vue?vue&type=template&id=14b1798d&scoped=true"
import script from "./nav-modular.vue?vue&type=script&lang=js"
export * from "./nav-modular.vue?vue&type=script&lang=js"
import style0 from "./nav-modular.vue?vue&type=style&index=0&id=14b1798d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b1798d",
  null
  
)

export default component.exports